import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MuiTextField, { TextFieldProps } from '@mui/material/TextField';
import { AppTheme } from '../../theme';
import { alpha, SvgIcon, useTheme } from '@mui/material';
import IconLib from '../../lib/icons/IconLib';


export default function PasswordField(props: any) {
    const theme: AppTheme = useTheme();
    const { initialShowPasswordIcon = false, ...restOfProps } = props;
    const [showPassword, setShowPassword] = React.useState<boolean>(
        initialShowPasswordIcon
    );
    const [hasError, setHasError] = React.useState(false);

    const { t } = useTranslation();

    React.useEffect(() => {
        if (!props.value) {
        setHasError(false);
        }
    }, [props.value]);

    const onChange: TextFieldProps['onChange'] = (event) => {
        const { value } = event.target;

        if (props.required) {
            setHasError(!event.target.value);
        }

        props.onChange?.(value, event);
    };

    const onBlur: TextFieldProps['onBlur'] = (event) => {
        if (props.required) {
        setHasError(!event.target.value);
        }

        props.onBlur?.(event);
    };

    const onIconClick = (): void => {
        setShowPassword((isPasswordVisible) => !isPasswordVisible);
    };

    return (
        <MuiTextField
            {...restOfProps}
            type={showPassword ? 'text' : 'password'}
            error={props.error || hasError}
            onChange={props.onChange && onChange}
            onBlur={onBlur}
            slotProps={{
                inputLabel: {
                    sx: {
                        color: theme.palette.neutral_0,
                    },
                },
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label={showPassword ? t('hidePassword') : t('showPassword')}
                                onClick={onIconClick}
                                edge="end"
                                size="large"
                            >
                                {showPassword ? 
                                        <SvgIcon component={IconLib.viewSvg} inheritViewBox title="" sx={{ fontWeight: "bold", color: theme.palette.primary.main}}></SvgIcon> 
                                    : 
                                        <SvgIcon component={IconLib.hiddenSvg} inheritViewBox title="" sx={{ fontWeight: "bold", color: theme.palette.primary.main}}></SvgIcon> 
                                }
                            </IconButton>
                        </InputAdornment>
                    ),
                    sx:{
                        width: "100%",
                        backgroundColor: theme.palette.neutral_4,
                        borderRadius: "8px",
                        '& .MuiFilledInput-root': {
                            overflow: 'hidden',
                            borderRadius: "8px",
                            border: '1px solid',
                            backgroundColor: theme.palette.neutral_4,
                            borderColor: theme.palette.neutral_4,
                            '&:hover': {
                                backgroundColor: 'transparent',
                            },
                            '&.Mui-focused': {
                                backgroundColor: 'transparent',
                                boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
                                borderColor: theme.palette.primary.main,
                            },
                        },
                        '.MuiOutlinedInput-notchedOutline': {
                            borderColor: (theme as AppTheme).palette.neutral_4,
                        },
                        '.MuiOutlinedInput-input': {
                            color: (theme as AppTheme).palette.neutral_0,
                        },
                    }
                }
            }}
        />
    );
}
